module.exports = __webpack_public_path__ + "img/medal.eb46f667.svg";